export const OptimizelyExperimentIds = {
  HardLink: process.env.NEXT_PUBLIC_OPTIMIZELY_AB_TEST_HARD_LINK ?? "",
};
